import { render, staticRenderFns } from "./GuestbookPage.vue?vue&type=template&id=2ac45f39&scoped=true&"
import script from "./GuestbookPage.vue?vue&type=script&lang=js&"
export * from "./GuestbookPage.vue?vue&type=script&lang=js&"
import style0 from "./GuestbookPage.vue?vue&type=style&index=0&id=2ac45f39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac45f39",
  null
  
)

export default component.exports